import React from 'react';
import { Table } from 'react-bootstrap';

import Loader from '../../common/components/notifications/Loader';
import Snack from '../../common/components/SnackMessage';

class ApiKeyManager extends React.Component {
    constructor (props) {
        super(props)
    }

    componentDidMount () {
        this.props.actions.getApiKey();
    }

    render () {
        if (this.props.keys.isResolving) return <Loader message="Fetching"/>;

        if (this.props.keys.requiresCreate) {
            return <div>
                <Snack isOpen={!!this.props.keys.error} timeout={4000}
                    message={(this.props.keys.error || {}).message || ''}
                    onClose={this.props.actions.shiftKeyError}
                    type="error"
                />

                <button className="btn btn-primary"
                    onClick={this.props.actions.createApiKey}
                >
                    <i className="fa fa-plus"/> Create API Key
                </button>
            </div>;
        }

        return <div>
            <Snack isOpen={!!this.props.keys.error} timeout={4000}
                message={(this.props.keys.error || {}).message || ''}
                onClose={this.props.actions.shiftKeyError}
                type="error"
            />

            <Table responsive bordered striped>
                <tbody>
                    <tr>
                        <td className="col-sm-3">
                            Api Key
                        </td>
                        <td>
                            <strong>{
                                (this.props.keys.data !== null) ?
                                this.props.keys.data : 'Not Created'
                            }</strong>
                        </td>
                    </tr>

                    <tr>
                        <td className="col-sm-3">
                            Client ID
                        </td>
                        <td>
                            <strong>{this.props.clientID}</strong>
                        </td>
                    </tr>
                </tbody>
            </Table>

            <p>
                <a href="https://invintus.api-docs.io/v2.5/introduction"
                    className="btn btn-primary" rel="noopener noreferrer"
                    target="_blank"
                >
                    <i className="fa fa-link"/> API Reference
                </a>
            </p>
        </div>
    }
}

export default ApiKeyManager
